import { useResetAtom } from 'jotai/utils'
import React from 'react'

import { useInvalidateSurveyFilterInformationMainQuery } from '~/components/features/SurveyFilterInformation'
import { useInvalidateSurveyQuery } from '~/hooks/useSurveyQuery'

import { dialogInfoAtom } from '../atoms'

export const useCloseDialogWithRefresh = () => {
  const resetDialogInfo = useResetAtom(dialogInfoAtom)

  const invalidateSurveyQuery = useInvalidateSurveyQuery()
  const invalidateSurveyFilterInformationMainQuery =
    useInvalidateSurveyFilterInformationMainQuery()

  return React.useCallback(async () => {
    await invalidateSurveyFilterInformationMainQuery()
    await invalidateSurveyQuery()
    resetDialogInfo()
  }, [
    invalidateSurveyFilterInformationMainQuery,
    invalidateSurveyQuery,
    resetDialogInfo,
  ])
}
